import React, { Component } from 'react';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { withRouter } from "react-router";

export class FileUpload extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedFileName: null
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    this.props.onSubmit(e)
  }

  styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      padding: '10px',
    },
  }


  render() {

    return (
      <Form style= { this.styles.container} onSubmit={ this.onSubmit }>
        <FormGroup style={{display: 'flex', flexDirection: 'column'}}>
          <Input type="file" name="report_file"
                 id="report_file"
                 onChange={ this.props.onChange }
                 encType="multipart/form-data"
                  />
        </FormGroup>
        <Button>Upload</Button>
      </Form>
    );
  }
}

export default withRouter(FileUpload)